<section class="closed-menu" [class.menu-electron-mac]="resizeManager.isMacApp"  [class.show-clodes-menu]="!menuOpen">
  @for (item of items; track item) {
    <div>
      @if(item.type == "button"){
        <div class="hover-bttn" [class.badge-active]="item.badge?.value()" [class.active]="item.activeRoutes?.includes(activatedPage)" (click)="item.action()" [hoverTitle]="{text: item.label, position: 'right'}">
          @if(item?.badge?.value() > 0 ){
            <div class="bttn-badge">{{item?.badge?.value()}}</div>
          }
          <ion-icon [name]="item.icon"></ion-icon>
        </div>
      }
      @else if(item.type == "seperator"){
      <div class="closed-menu-seperator"></div>
    }
    @else if(item.type == "icon"){
    <ion-icon [name]="item.icon" class="closed-menu-icon"></ion-icon>
  }
  @else if(item.type == "warning"){
  <div class="hover-bttn warning" [style.background]="item.background" [hoverTitle]="{text: item.label, position: 'right', background: item.background, backdropBlur: true}" (click)="item.action()">
    <ion-icon [name]="item.icon"></ion-icon>
  </div>
}
</div>
}
</section>